import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "image-card"
    }}>{`Image Card`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Flex>
  <Card width={[ 256, 320 ]} mx='auto'>
    <Image src='https://source.unsplash.com/random/512x384?space' />
    <Text>
      Image Card
    </Text>
  </Card>
</Flex>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      